import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack } from '@mui/material';
import { PurchaseOrderDetailsContext, PurchaseOrderDetailsValues } from '../../contexts/PurchaseOrderDetailsContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';

export const PurchaseOrderDetailsCopyConfirmModal = () => {
  const { copyOrderQuantities, showCopyModal, closeConfirmModal } = useContext(PurchaseOrderDetailsContext) as PurchaseOrderDetailsValues;
  const { t } = useTranslation('purchaseOrderDetails');
  return (
    <Dialog onClose={closeConfirmModal}
      open={showCopyModal}>
      <DialogTitle>
        {t('confirmCopyModal.title')}
        <CloseDialogAction onCancel={closeConfirmModal} />
      </DialogTitle>
      <DialogContent>
        <Typography>
          {t('confirmCopyModal.body')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Stack direction={{ xs: 'column', md: 'row' }}
          gap='6px'
          width='100%'>
          <Button variant='secondary'
            fullWidth
            size="lg"
            onClick={closeConfirmModal}>
            {t('confirmCopyModal.cancel')}
          </Button>
          <Button variant='primary'
            fullWidth
            size="lg"
            onClick={copyOrderQuantities}>
            {t('confirmCopyModal.confirm')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};